export const getUri = (uri: string) =>
  uri.replace('http://www.edamam.com/ontologies/edamam.owl#recipe_', '');
